import { Directive, Input } from '@angular/core';
import { LayoutElementDirective } from './layout-element.directive';

@Directive({
  selector: '[am-layout-header]',
})
export class LayoutHeaderDirective extends LayoutElementDirective {
  @Input() height = '75px';
}
